import { Color } from '@coast/schemas';
import { useWorkflowTagOptions } from '@shared/util/hooks/useWorkflowTagOptions';
import { notNil } from '@shared/util/notNil';
import { getTagOption } from './getTagOption';
import { Tag } from './tag';

interface Props {
  fieldName: string;
  tagValues: string[];
}

export function TagList({ fieldName, tagValues }: Props) {
  const { options } = useWorkflowTagOptions(fieldName);
  if (!tagValues) {
    return null;
  }

  const tags = tagValues.map(value => getTagOption(value, options)).filter(notNil);

  return (
    <>
      {tags.map(tag => {
        return (
          <Tag
            key={tag.id}
            color={tag.backgroundColor as Color}
            archived={tag.archived}
            label={tag.label}
          />
        );
      })}
    </>
  );
}
